import useMenuItems from "../../../../../hooks/useMenuItems";
import MenuItem from "./components/MenuItem";

function HeaderMenuItems() {
  const items = useMenuItems();
  return (
    <>
      {items.map((item) => (
        <MenuItem
          key={item.label}
          to={item.to}
          label={item.label}
          search={item.search}
          onClick={item.onClick}
        />
      ))}
    </>
  );
}

export default HeaderMenuItems;
